import React from 'react';
import { t, Lang } from '../../../../i18n';
import { getWellDefinedTasks, WellDefinedTaskId } from '../DialogueManagementDefinedTaskClassification/wellDefinedTasks';

interface WellDefinedTaskSuggestionsProps {
  lang: Lang;
  onSelectTask: (taskName: string) => void;
}

const WellDefinedTaskSuggestions: React.FC<WellDefinedTaskSuggestionsProps> = ({ lang, onSelectTask }) => {
  const tasks = getWellDefinedTasks(lang);

  const handleTaskClick = (taskName: string) => {
    // Call the handler - the parent component will handle hiding by checking for user messages
    onSelectTask(taskName);
  };

  return (
    <div style={{ 
      display: 'flex',
      flexWrap: 'wrap',
      gap: '8px',
      justifyContent: 'flex-end',
      marginTop: '8px',
      marginBottom: '8px'
    }}>
      {tasks.map((task: { id: WellDefinedTaskId; name: string }) => (
        <button
          key={task.id}
          onClick={() => handleTaskClick(task.name)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#E21E26',
            color: '#fff',
            border: 'none',
            borderRadius: '25px',
            fontSize: '14px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            outline: 'none',
            boxShadow: '0 2px 8px rgba(226, 30, 38, 0.4)',
            width: 'auto',
            minWidth: 'fit-content'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#C51B21';
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(197, 27, 33, 0.55)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#E21E26';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 8px rgba(226, 30, 38, 0.4)';
          }}
        >
          {task.name}
        </button>
      ))}
    </div>
  );
};

export default WellDefinedTaskSuggestions;

